import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { TextItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/textItemAttributes';

const ProfileCompletion = ({
  item,
  onChange,
}: Omit<ComponentSettingsTab<TextItemAttributes>, 'defaultAttributes'>) => (
  <DisplayOption
    title={__('Display profile completion')}
    item={item}
    onChange={onChange}
  />
);

export default ProfileCompletion;
